import Section from "./Section"
import { Link, Stack, Typography } from "@mui/material"

export default function Bottom() {
  return (
    <Section>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography fontSize={14} fontFamily="monospace">
          © 2025 WM-UP
        </Typography>
        <Link
          href="https://linkedin.com/company/wm-upp/"
          style={{ textDecoration: "none" }}
        >
          <Typography fontSize={14} fontFamily="monospace">
            LinkedIn
          </Typography>
        </Link>
        <Link href="https://www.freepik.com" style={{ textDecoration: "none" }}>
          <Typography fontSize={10}>Images by Freepik</Typography>
        </Link>
      </Stack>
    </Section>
  )
}
